import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';

type Tema = 'claro' | 'escuro';

interface ThemeContextType {
  tema: Tema;
  alternarTema: () => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

const CHAVE_TEMA = 'bravobet_tema';

function obterTemaInicial(): Tema {
  const salvo = localStorage.getItem(CHAVE_TEMA);
  if (salvo === 'claro' || salvo === 'escuro') return salvo;
  // Sem preferência salva: respeita a preferência do sistema operacional.
  const prefereEscuro = window.matchMedia?.('(prefers-color-scheme: dark)').matches;
  return prefereEscuro ? 'escuro' : 'claro';
}

export const ThemeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [tema, setTema] = useState<Tema>(obterTemaInicial);

  useEffect(() => {
    const root = document.documentElement;
    if (tema === 'escuro') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    localStorage.setItem(CHAVE_TEMA, tema);
  }, [tema]);

  const alternarTema = () => {
    setTema(t => (t === 'escuro' ? 'claro' : 'escuro'));
  };

  return (
    <ThemeContext.Provider value={{ tema, alternarTema }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme deve ser usado dentro de um ThemeProvider');
  }
  return context;
};
